export default "__VITE_ASSET__265fbe82__"